import React, { useState } from 'react'
import './App.css'
import Header from './header'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Sentence from './Sentence'
import queryString from 'query-string'

function App() {
      const [loading, setLoading] = useState(false)
      const [sentence, setSentence] = useState('')
      const [submittedSentence, setSubmittedSentence] = useState('')
      const [selectedDialect, setSelectedDialect] = useState<string>(
            'American English Dialect'
      )

      const [selectedRephrase, setSelectedRephrase] =
            useState<string>('Professional')

      const [spellingGrammar, setSpellingGrammar] = useState<string>('Check for spelling and grammar');


      React.useEffect(() => {
            const params = queryString.parse(window.location.search)
            if (params.dialect) setSelectedDialect(params.dialect as string)
            if (params.rephrase) setSelectedRephrase(params.rephrase as string)
      }, [])

      const handleSelectDialectChange = (
            event: React.ChangeEvent<HTMLSelectElement>
      ) => {
            console.log(event.target.value)
            setSelectedDialect(event.target.value)
            const params = queryString.parse(window.location.search)
            params.dialect = event.target.value
            window.history.pushState(
                  {},
                  '',
                  `${window.location.pathname}?${queryString.stringify(params)}`
            )
      }
      const handleSpellingGrammarChange = (
            event: React.ChangeEvent<HTMLSelectElement>
      ) => {
            console.log(event.target.value)
            setSpellingGrammar(event.target.value)
            const params = queryString.parse(window.location.search)
            params.spellingGrammar = event.target.value
            window.history.pushState(
                  {},
                  '',
                  `${window.location.pathname}?${queryString.stringify(params)}`
            )
      }
      const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault(); // Prevent default form submission

            if (submittedSentence) {
                  setSubmittedSentence('');
                  setTimeout(() => {
                        setLoading(true)
                        setSubmittedSentence(sentence)
                  }, 100)
            } else {
                  setLoading(true);
                  setSubmittedSentence(sentence);
            }
      }

      const handleSelectRephraseChange = (
            event: React.ChangeEvent<HTMLSelectElement>
      ) => {
            setSpellingGrammar('Check for spelling and grammar')
            console.log(event.target.value)
            setSelectedRephrase(event.target.value)
            const params = queryString.parse(window.location.search)
            params.rephrase = event.target.value
            window.history.pushState(
                  {},
                  '',
                  `${window.location.pathname}?${queryString.stringify(params)}`
            )
      }
      return (
            <div
                  className="App"
                  style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
            >
                  <Header />
                  <Container
                        style={{
                              width: '100%',
                              margin: '20px auto',
                              flex: '3',
                              display: 'flex',
                              flexDirection: 'column',
                        }}
                  >
                        <h3
                              className="app-title"
                        >
                              Wordsmith by Blue Canoe Learning
                        </h3>
                        <h4

                              className="app-sub-title"
                        >
                              Type a word or sentence that you'd like to say more effectively
                        </h4>
                        <Form onSubmit={handleSubmit}>
                              <Row className="mb-3">
                                    <Col xs={12}>
                                          <Form.Control
                                                type="text"
                                                placeholder="Enter a sentence"
                                                value={sentence}
                                                onChange={(e) => {
                                                      if (!loading)
                                                            setSentence(
                                                                  e.target.value
                                                            )
                                                }}
                                          />
                                    </Col>
                              </Row>
                              <Row className="mb-3">
                                    <Col style={{ flex: 1 }}>
                                          <Form.Select
                                                value={selectedDialect}
                                                onChange={handleSelectDialectChange}
                                          >
                                                <option>
                                                      American English Dialect
                                                </option>
                                                <option>
                                                      British English Dialect
                                                </option>
                                                <option>
                                                      Canadian English Dialect
                                                </option>
                                                <option>
                                                      Australian English Dialect
                                                </option>
                                                <option>
                                                      New Zealand English Dialect
                                                </option>
                                          </Form.Select>
                                    </Col>
                                    <Col style={{ flex: 1 }}>
                                          <Form.Select
                                                value={selectedRephrase}
                                                onChange={handleSelectRephraseChange}
                                          >
                                                <option>Professional</option>
                                                <option>Casual</option>
                                                <option>Sarcastic</option>
                                                <option>No change</option>
                                                {/* Add more options here */}
                                          </Form.Select>
                                    </Col>
                                    <Col style={{ flex: 1 }}>
                                          <Form.Select
                                                value={spellingGrammar}
                                                onChange={handleSpellingGrammarChange}
                                                disabled={selectedRephrase !== 'No change'}
                                          >
                                                <option>Check for spelling and grammar</option>
                                                <option>No change</option>
                                                {/* Add more options here */}
                                          </Form.Select>
                                    </Col>

                                    <Col style={{ flex: 1 }}>
                                          <Button
                                                style={{
                                                      width: '100%',
                                                      backgroundColor: '#0072cc',
                                                }}
                                                variant="primary"
                                                disabled={loading || sentence === ''}
                                                type="submit"
                                          >
                                                Submit
                                          </Button>
                                    </Col>
                              </Row>
                        </Form>
                        <Row
                              style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flex: '1',
                              }}
                        >
                              {submittedSentence !== '' && (
                                    <Sentence
                                          sentence={submittedSentence}
                                          dialect={selectedDialect}
                                          rephrase={selectedRephrase}
                                          spellingGrammar={spellingGrammar}
                                          onFinish={() => setLoading(false)}
                                    />
                              )}
                        </Row>

                  </Container>
                  <Container
                        style={{
                              flex: '2',
                              display: 'flex',
                              justifyContent: 'center',
                              flexDirection: 'column',
                              gap: '3px',
                        }}
                  >
                        <div className='app-text'>
                              The image you see here are Color Vowel® anchor images and are part of an exclusive patented system that delivers brain-based pronunciation strategies for English learners. Download the "Blue Canoe Learning" app to view all of the Color Vowels® and start learning with our AI tutor today.
                              Visit <a href='https://www.colorvowel.com'>colorvowel.com</a> to learn more about Color Vowels for learners, teachers, and schools.
                        </div>
                        <div className='app-text'>
                              Start practicing your pronunciation with our AI tutor today.

                        </div>
                        <div
                              style={{
                                    display: 'flex',
                                    gap: '10px',
                                    justifyContent: 'center',
                              }}
                        >
                              <a
                                    href="https://apps.apple.com/us/app/blue-canoe/id1243030457"
                                    target="blank"
                              >
                                    <img className='appStoreButton'
                                          src={
                                                'icons/download_button_appstore.png'
                                          }
                                          alt={`appstore`}
                                    />
                              </a>
                              <a
                                    href="https://play.google.com/store/apps/details?id=com.bluecanoelearning.bluecanoe"
                                    target="blank"
                              >
                                    <img className='appStoreButton'
                                          src={
                                                'icons/download_button_playstore.png'
                                          }
                                          alt={`googleplay`}
                                    />
                              </a>
                        </div>
                  </Container>
            </div>
      )
}

export default App
